
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsShopTypeDialog extends Serenity.EntityDialog<PsShopTypeRow, any> {
        protected getFormKey() { return PsShopTypeForm.formKey; }
        protected getIdProperty() { return PsShopTypeRow.idProperty; }
        protected getLocalTextPrefix() { return PsShopTypeRow.localTextPrefix; }
        protected getNameProperty() { return PsShopTypeRow.nameProperty; }
        protected getService() { return PsShopTypeService.baseUrl; }
        protected getDeletePermission() { return PsShopTypeRow.deletePermission; }
        protected getInsertPermission() { return PsShopTypeRow.insertPermission; }
        protected getUpdatePermission() { return PsShopTypeRow.updatePermission; }

        protected form = new PsShopTypeForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var Shoptypeid = Q.tryFirst(PsShopRow.getLookup().items,x => x.ShopTypeId == this.entity.ShopTypeId);
            if(Shoptypeid !=null) {
                this.deleteButton.toggleClass('disabled', true);
                                
            }
        }
        
        
    }
}